export default __webpack_public_path__ + "static/media/factura-final2.68286ad0.png";